import styled from 'styled-components';
import Banner768 from '../../../assets/illustrations/procedures/Banner_768.svg';
import Banner992 from '../../../assets/illustrations/procedures/Banner_992.svg';
import Banner1280 from '../../../assets/illustrations/procedures/Banner_1280.svg';
import Banner1920 from '../../../assets/illustrations/procedures/Banner_1920.svg';

export const ProcedureWrapper = styled.div<{
  gap: boolean;
}>`
  min-height: 100vh;
  width: 100%;
  padding: 2rem 1rem 2rem 1rem;
  display: flex;
  gap: ${(props) => (props.gap ? '2rem;' : '0;')};
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: 992px) {
    padding: calc(72px + 3rem) 3rem 3rem calc(88px + 3rem);
  }
`;

export const ContainerLink = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 26px 0px 0px 0px;

  @media (min-width: 640px) {
    justify-content: flex-start;
    padding-left: 40px;
  }

  @media (min-width: 992px) {
    padding-left: 38px;
  }

  @media (min-width: 1280px) {
    width: 1128px;
    padding-left: 0px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    margin-top: 26px;
  }
`;

export const Container = styled.div`
  padding: 0px;
  display: flex;
  flex-direction: column;
  align-content: space-between;

  & .header {
    background: var(--background-background-disabled) center no-repeat;

    margin: 0px;
    padding: 48px 0px;
    /* background-image: none; */
  }

  & .searchForm {
    gap: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 16px;
    padding-right: 16px;
    & h1 {
      font-size: 24px;
      line-height: 32px;
      font-weight: 900;
      color: var(--text-text02);
    }
  }

  & .categories {
    padding: 32px 0px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    & h1 {
      font-weight: 900;
      font-size: 20px;
      line-height: 32px;
      width: 100%;
      color: var(--text-text02);
      text-align: center;
    }
  }

  & .historical {
    background-color: var(--background-background05);
    display: flex;
    justify-content: center;
    width: 100%;
  }

  & .historicalWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 16px 16px 16px;

    & h2 {
      font-weight: 900;
      font-size: 14px;
      line-height: 20px;
      width: 100%;
      color: var(--text-text02);
    }

    & button.btn-goto-history {
      min-width: 130px;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
    }
  }

  & .procedures {
    background-color: var(--background-background05);
  }

  & .historicalOthersWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 16px 16px 16px;

    & h2 {
      font-weight: 900;
      font-size: 14px;
      line-height: 20px;
      width: 100%;
      color: var(--text-text02);
    }

    & button.btn-goto-history {
      min-width: 109px;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
    }
  }

  & .otherProcedures {
    background-color: var(--background-background05);
    padding-bottom: 24px;
  }

  & .contactSection {
    padding: 8px 16px;
  }

  @media (min-width: 768px) {
    & .header {
      padding: 68px 0px 96px 0px;
      background: url('${Banner768}') center repeat-x;
      & h1 {
        font-size: 32px;
      }
    }

    & .historicalWrap {
      // padding: 42px 24px 26px 24px;
      padding-left: 24px;
      padding-right: 24px;
    }
    & .historicalOthersWrap {
      // padding: 42px 24px 26px 24px;
      padding-left: 24px;
      padding-right: 24px;
    }
    & .searchForm {
      width: 348px;
      align-items: flex-start;
      padding-left: 24px;
    }
  }

  @media (min-width: 992px) {
    padding: 70px 0px 0px 88px;

    & .header {
      background: url('${Banner992}') center repeat-x;
    }

    .procedure__block {
      margin: 24px 0 86px 0;
    }

    & .historicalWrap {
      //   padding: 42px 16px 28px 32px;
      padding-left: 32px;
      padding-right: 32px;
    }
    & .historicalOthersWrap {
      padding-left: 32px;
      padding-right: 32px;
    }
    & .otherProcedures {
      padding-bottom: 32px;
    }
    & .contactSection {
      padding: 32px 32px;
    }
    & .searchForm {
      width: 408px;
      padding-left: 32px;
    }
  }

  @media (min-width: 1280px) {
    & .header {
      background: url('${Banner1280}') center repeat-x;
    }
    & .headeContainer {
      width: 1128px;
      margin: 0 auto;
      padding: 0;
    }
    & .historicalWrap {
      width: 1128px;
      padding-top: 32px;
      padding-left: 0px;
      padding-right: 0px;
    }
    & .historicalOthersWrap {
      width: 1128px;
      padding-left: 0px;
      padding-right: 0px;
    }
    & .searchForm {
      padding: 0;
      width: 456px;
    }
  }

  @media (min-width: 1920px) {
    & .header {
      background: url('${Banner1920}') center repeat-x;
    }
  }

  button.btn-goto-history:focus {
    outline: 1px solid #5b36f2;
    border-radius: 4px;
  }
`;
